function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { EmailIcon, EnquireIcon } from '@domain-group/fe-co-icon';
import { EventBoundary, useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import AgentCarousel from './agent-carousel';
import AgencyLogos from './sidebox-agency-logos';
import NextEvent from './next-event';
import * as styles from './agent-sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentSidebox = _ref => {
  var agents = _ref.agents,
    inspection = _ref.inspection,
    applyOnlineLink = _ref.applyOnlineLink,
    _ref$onEmailClick = _ref.onEmailClick,
    onEmailClickProp = _ref$onEmailClick === void 0 ? () => {} : _ref$onEmailClick;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    callButtonClicked = _useState4[0],
    setCallButtonClicked = _useState4[1];
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var largePhoto = Boolean(toggledFeatures === null || toggledFeatures === void 0 ? void 0 : toggledFeatures[ToggledFeatureKey.AGENCY_BRANDING]);
  var agent = agents[index] || {};
  var agencies = agents.map(each => each.agency);
  var updateAgent = (_currentSlide, newIndex) => setIndex(newIndex);
  var onEmailClick = () => {
    sendEvent('email-click');
    onEmailClickProp(null, agent);
  };
  return ___EmotionJSX("div", {
    css: styles.sidebox
  }, ___EmotionJSX(AgencyLogos, {
    agencies: agencies,
    active: index
  }), ___EmotionJSX("div", {
    css: styles.inner
  }, inspection && ___EmotionJSX(NextEvent, {
    inspection: inspection
  }), !isEmpty(agents) && ___EmotionJSX(AgentCarousel, {
    agents: agents,
    beforeChange: updateAgent,
    isAutoplay: !callButtonClicked,
    largePhoto: largePhoto
  }), agent.phone && ___EmotionJSX(EventBoundary, {
    data: {
      agentId: agent.id,
      agentName: agent.name,
      agencyId: agent.agency.id,
      agencyName: agent.agency.name,
      index
    }
  }, ___EmotionJSX(CallButton, {
    css: styles.phoneButton,
    key: agent.phone,
    phone: agent.phone,
    onClick: () => setCallButtonClicked(true)
  })), ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    css: styles.button,
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: onEmailClick
  }, "Email"))), applyOnlineLink && ___EmotionJSX("div", {
    css: styles.applyOnlineContainer
  }, ___EmotionJSX(LinkButton, {
    css: styles.applyOnlineButton,
    appearance: "ghostNeutral",
    icon: ___EmotionJSX(EnquireIcon, null),
    href: applyOnlineLink,
    onClick: () => sendEvent('apply-online-click'),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Apply online")));
};
export default withEventBoundary('agent-sidebox')(AgentSidebox);